import { AppTheme } from './app-theme';
import { environment } from '../../../environments/environment';

/** API host without /api suffix — from environment (local, QA, prod). */
export function getApiOrigin(): string {
  return environment.apiBaseUrl.replace(/\/api\/?$/i, '');
}

/**
 * Resolve logo for display: API /branding/... uses current environment API origin.
 * Falls back to the given default (site or home/letter static asset).
 */
export function resolveBrandingLogoUrl(
  url?: string | null,
  fallback: string = AppTheme.siteLogoSrc
): string {
  if (!url?.trim()) {
    return fallback;
  }

  let value = url.trim();

  if (/^https?:\/\//i.test(value)) {
    try {
      const parsed = new URL(value);
      if (/\/branding\//i.test(parsed.pathname)) {
        value = `${parsed.pathname}${parsed.search}`;
      } else {
        return value;
      }
    } catch {
      return fallback;
    }
  }

  if (value.startsWith('data:')) {
    return value;
  }

  if (value.startsWith('assets/')) {
    return value;
  }

  if (value.startsWith('/')) {
    return `${getApiOrigin()}${value}`;
  }

  return value;
}
